import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "@/services/axiosAuth";
import { BILLING_CONFIG } from "./apiRoutes";

interface mutateProps {
  pricingId: string;
  communityId: string;
  id: string;
  data?: FieldValues;
}

const mutateTriggerExecution = async ({
  pricingId,
  communityId,
  id,
  data,
}: mutateProps) => {
  return await axiosAuth.post(
    `${BILLING_CONFIG(communityId)}/${pricingId}/executions/${id}/trigger`,
    data
  );
};

const useTriggerExecutionMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateTriggerExecution,
    ...queryParams,
  });

export default useTriggerExecutionMutation;
